module.exports = __webpack_public_path__ + "static/media/cabecera-login.1afb7c1c.png";